module.exports = __webpack_public_path__ + "static/media/HV9.d079b8ef.jpg";